/**
 * 各库的国际化切换
 */
import Vue from 'vue'

function reviseLocale(locale) {
  if(locale.includes('-')) {
    // 如zh-cn的情况
    const localeArr = locale.split('-')
    return localeArr[0].toLowerCase() + '-' + localeArr[1].toUpperCase()
  } else if(locale.includes('_')) {
    const localeArr = locale.split('_')
    return localeArr[0].toLowerCase() + '-' + localeArr[1].toUpperCase()
  } else {
    // 如en的情况
    return locale.toLowerCase()
  }
}

function getUrlQuery() {
  const url = decodeURI(location.search)
  let query = {}
  if (url.indexOf('?') != -1) {
    const str = url.substr(1)
    const pairs = str.split('&')
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=')
      query[pair[0]] = pair[1]
    }
  }
  return query
}

async function setArkLocale(v) {
  const params = getUrlQuery()
  let locale = v || reviseLocale(params.locale || localStorage.getItem('r3-lang') || 'zh-CN')
  if (locale === 'zh') {
    locale = 'zh-CN' // 中文以zh-CN为准，并要兼容之前的zh。包文件是zh-CN。设置时再换成zh-CN
  } else if (locale.startsWith("zh") && locale !== 'zh-CN'){
    locale = 'zh-CHT'
  } else if(['en', 'en-US','en-GB'].includes(locale)){
    locale = 'en'
  }
  const currentLocale = locale
  import(`/static/ark-ui/locale/${currentLocale}.js`)
  .then(res => {
    console.log('import::', res.default.i.locale);
    if (!('Ark/locale' in window)) {
      window['Ark/locale'] = {}
    }
    window['Ark/locale'].default = res.default
    Vue.use(Ark, { locale: res.default })
    Ark.lang(currentLocale)
  })
  .catch(err => {
    console.error(err);
  });
 /* const res = await axios
    // .get(`/cdn/ark-ui@1.4.7/locale/${currentLocale}.js`)
    .get(`/static/ark-ui/locale/${currentLocale}.js`)
    .then((res) => {
      if (res.status === 200) {
      return res.data
    } else {
      return undefined
    }
  })
  .catch((err) => {
    console.error(err)
    return undefined
  })
  if(res) {
    console.log('allLang::res::', res);
    // const func = new Function(`${res}()`)
    // func()
    // ArkLanguagePackage = window['Ark/locale'].default
  } */
}

async function setLocale(lang, http) {
  let message = ["zh", "en"].includes(lang)
    ? t('切换成功！')
    : lang;
  switch (message) {
    case "ja":
      message = "暂无日语语言包，敬请期待！(已默认使用中文)";
      break;
    default:
      break;
  }
  if (!["zh", "en"].includes(lang)) {
    lang = "zh";
  }
  let _lang
  switch (lang) {
    case 'en':
      _lang = 'en-US'
      break;
    default:
      _lang = 'zh-CN'
      break;
  }

  localStorage.setItem('r3-lang',_lang) // 保证在系统内切换后第一个发出的请求请求头语言正确
  let flag
  if (http) {
    const pa = new FormData();
    pa.append('language', _lang || localStorage.getItem('locale'));
    const { status, data } = await $service.common.publicUrlParams('/p/cs/refreshLanguage', pa);
    flag = status === 200 && data.code === 0;
  }
  // console.log('falg::', flag, lang);
  if (!http || http != 1 || (http && flag)) {
    localStorage.setItem("locale", lang);
    // console.log('language::', lang);
    R3.store.commit(`customize/language`, lang || "zh");

    // this.$Message.success(message);

    await setArkLocale(_lang); // ArkUI
    R3I18n(_lang); // R3 + Bcl
    $i18n.locale = lang; // 项目
    await VoerkaI18n.change(lang); // 项目
    vm._i18n.locale = lang

    if (http == 2) {
      window.location.reload()
    }
  } else {
    localStorage.setItem("locale", lang); // 登录成功的回调
  }
}

export default setLocale
